"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eTrailerInterchangeDeductible = exports.eTrailerInterchangeLimit = void 0;
const endorsements_class_1 = require("./endorsements.class");
var eTrailerInterchangeLimit;
(function (eTrailerInterchangeLimit) {
    eTrailerInterchangeLimit["TEN_THOUSAND"] = "10000";
    eTrailerInterchangeLimit["TWENTY_FIVE_THOUSAND"] = "25000";
    eTrailerInterchangeLimit["THIRTY_THOUSAND"] = "30000";
    eTrailerInterchangeLimit["THIRTY_FIVE_THOUSAND"] = "35000";
    eTrailerInterchangeLimit["FORTY_THOUSAND"] = "40000";
    eTrailerInterchangeLimit["FORTY_FIVE_THOUSAND"] = "45000";
    eTrailerInterchangeLimit["FIFTY_THOUSAND"] = "50000";
    eTrailerInterchangeLimit["FIFTY_FIVE_THOUSAND"] = "55000";
    eTrailerInterchangeLimit["SIXTY_THOUSAND"] = "60000";
    eTrailerInterchangeLimit["SIXTY_FIVE_THOUSAND"] = "65000";
    eTrailerInterchangeLimit["SEVENTY_FIVE_THOUSAND"] = "75000";
    eTrailerInterchangeLimit["ONE_HUNDRED_THOUSAND"] = "100000";
})(eTrailerInterchangeLimit = exports.eTrailerInterchangeLimit || (exports.eTrailerInterchangeLimit = {}));
var eTrailerInterchangeDeductible;
(function (eTrailerInterchangeDeductible) {
    eTrailerInterchangeDeductible["ONE_THOUSAND"] = "1000";
    eTrailerInterchangeDeductible["TWO_THOUSAND_FIVE_HUNDRED"] = "2500";
    eTrailerInterchangeDeductible["FIVE_THOUSAND"] = "5000";
    eTrailerInterchangeDeductible["TEN_THOUSAND"] = "10000";
    eTrailerInterchangeDeductible["TWENTY_FIVE_THOUSAND"] = "25000";
    eTrailerInterchangeDeductible["FIFTY_THOUSAND"] = "50000";
    eTrailerInterchangeDeductible["ONE_HUNDRED_THOUSAND"] = "100000";
})(eTrailerInterchangeDeductible = exports.eTrailerInterchangeDeductible || (exports.eTrailerInterchangeDeductible = {}));
exports.default = endorsements_class_1.Endorsements;
//# sourceMappingURL=index.js.map